import { render, staticRenderFns } from "./SensorView.vue?vue&type=template&id=6faa4d4a"
import script from "./SensorView.vue?vue&type=script&lang=js"
export * from "./SensorView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports